export default __webpack_public_path__ + "static/graphik-regular-web-a96f914289a26a1c182bae0984769f18.woff2";